import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import { AchooPopupComponent } from '../../../core/achoo-popup/achoo-popup.component';

@Component({
  selector: 'achoo-modal',
  templateUrl: './achoo-modal.component.html',
  styleUrls: ['./achoo-modal.component.scss']
})
export class AchooModalComponent extends AchooPopupComponent {
  @ViewChild('content')
  public content: ElementRef;

  constructor() {
    super();
  }
}



// WEBPACK FOOTER //
// ./src/app/influencer-platform/influencer-settings/achoo-modal/achoo-modal.component.ts